import { render, staticRenderFns } from "./RoomCalendar.vue?vue&type=template&id=2b089953"
import script from "./RoomCalendar.vue?vue&type=script&lang=js"
export * from "./RoomCalendar.vue?vue&type=script&lang=js"
import style0 from "./RoomCalendar.vue?vue&type=style&index=0&id=2b089953&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports